import './bootstrap';

import { createApp } from 'vue';
import { i18nVue } from 'laravel-vue-i18n';

import App from './App.vue'
import router from './Router';
import store from "./Store";

import VueSweetalert2 from 'vue-sweetalert2';
import VueTheMask from 'vue-the-mask'
//import DataPicker from 'vue-datepicker-next';
import PrimeVue from 'primevue/config';
import moment from 'moment';

//import 'vue-datepicker-next/index.css';
//import 'vue-datepicker-next/locale/pt-br';
import 'sweetalert2/dist/sweetalert2.min.css';
import "primevue/resources/themes/lara-light-indigo/theme.css";
import "vue3-toastify/dist/index.css";


const app = createApp(App)
    .use(i18nVue)
    .use(store)
    .use(router)
    .use(VueSweetalert2)
    .use(VueTheMask)
    .use(PrimeVue);
  //  .use(DataPicker);

app.config.globalProperties.$business_id = 1

app.component('formatarData', {
    filters: {
        formatarData: function (data, formato) {
        return moment(data).format(formato);
        }
    }
});



app.mount("#app");
